
define('text!templates/modules/goal/story/goal-story-list-item.html',[],function () { return '<div class="weight-date ucolfix">{{date}}</div>\n<div class="weight-value ucolfix">{{value}} <span class="weight-unit">{{unit}}</span></div>\n';});

